// AutoGenerated
export class HesapSarkiSesKayitNotlarModel {
    hesapSarkiSesKayitModelId!: string;
    sayfaNo!: number;
    koordinat!: string | null;
    sure!: number;
    renkKod!: string | null;
    yorumlar!: string | null;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}